export default {
    "Sign Out": "Deconnexion",
    "Edit Profile": "Editer le profil",
    "Accounting Location": "Lieu de comptabilite"
}